import { render, staticRenderFns } from "./ViewReceivedBy.vue?vue&type=template&id=4173113e&scoped=true&"
import script from "./ViewReceivedBy.vue?vue&type=script&lang=js&"
export * from "./ViewReceivedBy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4173113e",
  null
  
)

export default component.exports